import Model from './model'

class Agency extends Model({
  minHours: undefined,
  slots: undefined,
}) {}

export { Agency as default }
